import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

import './FormImageSelect.css';

const FormImageSelect = ({ product, handleChange }) => {

  const { label, options } = product;

  return (

    <div className="form-group mb-4">
      <label className="font-weight-bold lead">{label}</label><span title="required" className="text-muted FontAwesome">*</span>
      <div className="d-sm-flex flex-wrap">
        {options.map(item => {

          const { id, name, value, image, info } = item;
          const index = options.indexOf(item);
          
          return (
            <div key={index}>
            <div className="form-check d-flex flex-column mr-4" >
              <button type="button" data-toggle="modal" data-target={`#iconModal-${id}`} className="btn btn-outline-secondary border-0 p-3 p-sm-4 shadow-sm"><figure className={`${image} m-0`}><div className="p-5" /></figure></button>
              <div className="mt-2">
              <input
                type="radio"
                id={id}
                className="FormImageSelect-input form-check-input mb-1 ml-0" 
                name={name} 
                value={value} 
                onChange={(item) => handleChange(item)}
                required
              />
              <label htmlFor={id} className="form-check-label ml-4 FormImageSelect-input-label">
                <span className="">{value}</span> 
              </label>
              {(info !== undefined)
              ?
              <>
              <small className="ml-1"  title={info}  data-toggle="modal" data-target={`#infoModal-${id}`}> 
                <FontAwesomeIcon className="FontAwesome text-muted" icon={faInfoCircle} />
              </small>
              <div className="modal fade" id={`infoModal-${id}`} tabIndex="-1" role="dialog" aria-labelledby={`infoModal-${id}Label`} aria-hidden="true">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header bg-primary">
                      <button type="button" className="close text-light" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                    {info}
                    </div>
                  </div>
                </div>
              </div>  
              </>
              :
              null
              }
              </div>
            </div>      
              <div className="modal fade" id={`iconModal-${id}`} tabIndex="-1" role="dialog" aria-labelledby={`iconModal-${id}`} aria-hidden="true">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header bg-primary">
                      <span className="text-light lead">{value}</span>
                      <button type="button" className="close text-light" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <figure className={`${image}`}><div className={`FormImageSelect-modal-screen ${image}-modal`} /></figure>
                    </div>
                  </div>
                </div>
              </div>  
            </div>
          
          )
        })}
      </div>
    </div>
  );
}

export default FormImageSelect;